
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93UA8qBAjww0Meta } from "/var/www/menaceking/pages/[...slug].vue?macro=true";
import { default as autologin4jCw8b5WUPMeta } from "/var/www/menaceking/pages/auth/autologin.vue?macro=true";
import { default as callback7e1ygsifakMeta } from "/var/www/menaceking/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as bettingc2t0QViYdMMeta } from "/var/www/menaceking/pages/betting.vue?macro=true";
import { default as _91pageIdentity_93H5yoyEOyiLMeta } from "/var/www/menaceking/pages/bonus/[pageIdentity].vue?macro=true";
import { default as _91categoryIdentity_93OdK9ZvVatGMeta } from "/var/www/menaceking/pages/categories/[categoryIdentity].vue?macro=true";
import { default as categoriesvuM8r2AjFdMeta } from "/var/www/menaceking/pages/categories.vue?macro=true";
import { default as contact1VSaSgCv33Meta } from "/var/www/menaceking/pages/contact.vue?macro=true";
import { default as favorites_46clienteyvZmPvrseMeta } from "/var/www/menaceking/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/menaceking/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93Brdx5ow6JkMeta } from "/var/www/menaceking/pages/games/[id].vue?macro=true";
import { default as index9ClMPNavejMeta } from "/var/www/menaceking/pages/index.vue?macro=true";
import { default as loyalty9lZX86HYDOMeta } from "/var/www/menaceking/pages/loyalty.vue?macro=true";
import { default as main6JZklOzzHrMeta } from "/var/www/menaceking/pages/main.vue?macro=true";
import { default as bonusesF84jLv4SnOMeta } from "/var/www/menaceking/pages/profile/bonuses.vue?macro=true";
import { default as documents8kL0fB1jLPMeta } from "/var/www/menaceking/pages/profile/documents.vue?macro=true";
import { default as historyWWJ5wNTHtlMeta } from "/var/www/menaceking/pages/profile/history.vue?macro=true";
import { default as info0KkzXJLP67Meta } from "/var/www/menaceking/pages/profile/info.vue?macro=true";
import { default as limitslYQfovcjFLMeta } from "/var/www/menaceking/pages/profile/limits.vue?macro=true";
import { default as notifications2oLYhmUfAxMeta } from "/var/www/menaceking/pages/profile/notifications.vue?macro=true";
import { default as securityrIOPQOIkjFMeta } from "/var/www/menaceking/pages/profile/security.vue?macro=true";
import { default as verificationLhBJlig0HZMeta } from "/var/www/menaceking/pages/profile/verification.vue?macro=true";
import { default as wallet4cST4MwsIfMeta } from "/var/www/menaceking/pages/profile/wallet.vue?macro=true";
import { default as profile_46clientJa3Sp9fGHZMeta } from "/var/www/menaceking/pages/profile.client.vue?macro=true";
import { default as providersTdqfjluNGYMeta } from "/var/www/menaceking/pages/providers.vue?macro=true";
import { default as _91pageIdentity_93uzHWAHk698Meta } from "/var/www/menaceking/pages/questions/[pageIdentity].vue?macro=true";
import { default as questionsBolIfoenctMeta } from "/var/www/menaceking/pages/questions.vue?macro=true";
import { default as recently_45played_46client8fl4PYjaGLMeta } from "/var/www/menaceking/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_935XRbAAjlU1Meta } from "/var/www/menaceking/pages/static/[pageIdentity].vue?macro=true";
import { default as _91identity_93BAmJKqCX8uMeta } from "/var/www/menaceking/pages/tournaments/[identity].vue?macro=true";
import { default as indexKTUQXkFLUwMeta } from "/var/www/menaceking/pages/tournaments/index.vue?macro=true";
import { default as welcome_45packageyX83ZjTjXGMeta } from "/var/www/menaceking/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/var/www/menaceking/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/var/www/menaceking/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/var/www/menaceking/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "betting",
    path: "/betting",
    component: () => import("/var/www/menaceking/pages/betting.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/var/www/menaceking/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriesvuM8r2AjFdMeta || {},
    component: () => import("/var/www/menaceking/pages/categories.vue"),
    children: [
  {
    name: "categories-categoryIdentity",
    path: ":categoryIdentity()",
    component: () => import("/var/www/menaceking/pages/categories/[categoryIdentity].vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/var/www/menaceking/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/var/www/menaceking/pages/favorites.client.vue"))
  },
  {
    name: "games-id",
    path: "/games/:id()",
    component: () => import("/var/www/menaceking/pages/games/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/menaceking/pages/index.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/var/www/menaceking/pages/loyalty.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/var/www/menaceking/pages/main.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/var/www/menaceking/pages/profile.client.vue")),
    children: [
  {
    name: "profile-bonuses",
    path: "bonuses",
    component: () => import("/var/www/menaceking/pages/profile/bonuses.vue")
  },
  {
    name: "profile-documents",
    path: "documents",
    component: () => import("/var/www/menaceking/pages/profile/documents.vue")
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/var/www/menaceking/pages/profile/history.vue")
  },
  {
    name: "profile-info",
    path: "info",
    component: () => import("/var/www/menaceking/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/var/www/menaceking/pages/profile/limits.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/var/www/menaceking/pages/profile/notifications.vue")
  },
  {
    name: "profile-security",
    path: "security",
    component: () => import("/var/www/menaceking/pages/profile/security.vue")
  },
  {
    name: "profile-verification",
    path: "verification",
    component: () => import("/var/www/menaceking/pages/profile/verification.vue")
  },
  {
    name: "profile-wallet",
    path: "wallet",
    component: () => import("/var/www/menaceking/pages/profile/wallet.vue")
  }
]
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/var/www/menaceking/pages/providers.vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsBolIfoenctMeta || {},
    component: () => import("/var/www/menaceking/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/var/www/menaceking/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/var/www/menaceking/pages/recently-played.client.vue"))
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/var/www/menaceking/pages/static/[pageIdentity].vue")
  },
  {
    name: "tournaments-identity",
    path: "/tournaments/:identity()",
    component: () => import("/var/www/menaceking/pages/tournaments/[identity].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/var/www/menaceking/pages/tournaments/index.vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/var/www/menaceking/pages/welcome-package.vue")
  }
]